import React from 'react'
import AdmRegistration from '../../components/AdminTabs/AdminRegistration/AdmRegistration'

const Registration = () => {
  return (
    <div>
        <AdmRegistration />
    </div>
  )
}

export default Registration